import { render, staticRenderFns } from "./UserScientificDegreeDelete.vue?vue&type=template&id=93747e90&"
import script from "./UserScientificDegreeDelete.vue?vue&type=script&lang=js&"
export * from "./UserScientificDegreeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports